import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { TagTranslation } from '../../shared/types/tag';
import { tagsApi } from '../services/TagsService';
import { tagTranslationsApi } from '../services/TagsTranslationService';

interface ITagsSlice {
  translations: TagTranslation[];
}

const initialState: ITagsSlice = {
  translations: [],
};

const slice = createSlice({
  name: 'tagsTranslations',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      tagTranslationsApi.endpoints.getTranslations.matchFulfilled,
      (state: ITagsSlice, { payload }) => {
        return { ...state, ...payload };
      },
    );
    builder.addMatcher(
      tagTranslationsApi.endpoints.createTranslation.matchFulfilled,
      (state: ITagsSlice, { payload: { translation } }) => {
        return {
          ...state,
          tags: [translation, ...state.translations],
        };
      },
    );
    builder.addMatcher(
      tagsApi.endpoints.deleteTagById.matchFulfilled,
      (state: ITagsSlice, { meta }) => {
        const translationId = meta.arg.originalArgs;
        return {
          ...state,
          tags: state.translations.filter((translation) => translation.id !== translationId),
        };
      },
    );
  },
});

export default slice.reducer;

export const selectTranslations = (state: RootState) => state.tagsTranslations.translations;

